'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svg = require('../../utils/svg.utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var controls = (0, _svg.getSvgControls)();
var Svg = controls.Svg,
    Path = controls.Path;

var Computer = function (_React$Component) {
    _inherits(Computer, _React$Component);

    function Computer() {
        _classCallCheck(this, Computer);

        return _possibleConstructorReturn(this, (Computer.__proto__ || Object.getPrototypeOf(Computer)).apply(this, arguments));
    }

    _createClass(Computer, [{
        key: 'render',
        value: function render() {
            return _react2.default.createElement(
                Svg,
                { width: '26', height: '32', viewBox: '0 0 26 32' },
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M9.073 10.012c-.293.033-.518.28-.518.578v9.174c0 .32.26.58.582.58h7.352v1.19c-.756.022-1.44.074-1.982.165-.34.056-.62.122-.863.217-.122.048-.233.102-.354.2s-.29.295-.29.573c0 .276.16.464.282.563s.242.152.364.2c.244.096.524.16.863.218.678.115 1.57.183 2.562.183.99 0 1.884-.068 2.563-.182.34-.056.62-.12.863-.217.122-.048.242-.1.363-.2s.283-.288.283-.563c0-.278-.16-.474-.282-.573s-.24-.152-.362-.2c-.243-.096-.524-.162-.863-.218-.543-.09-1.224-.144-1.98-.165v-1.19h7.36c.32 0 .582-.26.582-.582v-9.17c0-.32-.26-.58-.582-.58H9.14c-.01-.002-.02-.002-.032-.002l-.033.002zm.645 1.164H24.43v8.006H9.718v-8.006zM.58 8.148c-.32 0-.58.26-.58.58v14.54c0 .322.26.582.58.582h6.915c.32 0 .58-.26.58-.58V8.73c0-.322-.26-.582-.58-.582H.58zm.583 1.163h5.752V22.69H1.163V9.31z' }),
                _react2.default.createElement(Path, { fill: this.props.fill,
                    d: 'M4.033 20.71h-.01c-.32 0-.582.26-.582.582s.26.582.583.582h.032c.32 0 .582-.26.582-.582s-.26-.582-.582-.582h-.022zM4.033 18.075h-.01c-.32 0-.582.26-.582.582s.26.582.583.582h.032c.32 0 .582-.26.582-.583s-.26-.582-.582-.582h-.022zM2.585 10.064h-.007c-.32 0-.582.26-.582.582s.26.582.582.582H5.5c.322 0 .583-.26.583-.582s-.26-.582-.582-.582H2.586zM2.585 12.7h-.007c-.32 0-.582.26-.582.58s.26.583.582.583H5.5c.322 0 .583-.26.583-.582s-.26-.58-.582-.58H2.586z' })
            );
        }
    }]);

    return Computer;
}(_react2.default.Component);

Computer.propTypes = {
    fill: _react2.default.PropTypes.string
};

exports.default = Computer;


//////////////////
// WEBPACK FOOTER
// ./~/pluton-assets/lib/icons/svg/computer.js
// module id = 1090
// module chunks = 0